<script>
import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faYoutubeSquare,
  faLinkedin,
} from '@fortawesome/free-brands-svg-icons';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(
  faYoutubeSquare,
  faLinkedin,
  faChevronDown,
);

export default FontAwesomeIcon;
</script>
